export default __webpack_public_path__ + "static/2-78742b04ad175d0c03891cc69f07309e.jpeg";